import { Loading, Notification } from "#/atoms";

import { RegisterWorkerParams } from "@/api/account/interface";
import { SignupWorker } from "#/pages";
import { useApi } from "@/api";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const SignupWorkerView = () => {
  const navigate = useNavigate();
  const { account, errorMessage, loading } = useApi()

  // useEffect(() => {
  //   if (session.user) {
  //     navigate('/', { replace: true })
  //   }
  // }, [session]);

  const handleLogin = useCallback(() => {
    navigate('/login', { replace: true })
  }, []);

  const handleSignup = useCallback(() => {
    navigate('/register', { replace: true })
  }, []);

  const handleSignupWorker = useCallback((data: RegisterWorkerParams) => {
    account.registerWorker(data);
  }, []);

  return (
    <>
      {loading && <Loading />}
      {errorMessage && <Notification>{errorMessage}</Notification>}
      <SignupWorker onLogin={handleLogin} onSignupWorker={handleSignupWorker} onSignup={handleSignup} />
    </>
  );
}

export default SignupWorkerView;